import { useUserContext } from "@/contexts/user";
import { ReactNode } from "react";
import { ConditionalRoute } from "./ConditionalRoute";

export function GuestRoute({ children }: { children: ReactNode }) {
    const { user, authReady } = useUserContext();

    return <ConditionalRoute
        children={children}
        condition={!user}
        loading={!authReady}
    />;
}